import { Switch } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { MAP_SETTINGS_TABS, MapSettingsTab } from '../mapSettingsConfig';

interface MapSettingsTabsProps {
  activeTab: MapSettingsTab;
  onChange: (_tab: MapSettingsTab) => void;
}

/** Segmented control across the top of the map settings sheet. */
const MapSettingsTabs: FC<MapSettingsTabsProps> = ({ activeTab, onChange }) => (
  <Switch.Group
    name="map-settings-tab"
    type="normal"
    value={activeTab}
    onChange={(event) => onChange(event.target.value as MapSettingsTab)}
  >
    {MAP_SETTINGS_TABS.map(({ id, label }) => (
      <Switch key={id} id={`map-settings-tab-${id}`} value={id}>
        {label}
      </Switch>
    ))}
  </Switch.Group>
);

export default MapSettingsTabs;
